import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
} from "./actionTypes";

const initialState = {
  currentUser: null,
  error: "",
  loading: false,
  successMsg: "",
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case GET_CURRENT_USER:
      state = {
        ...state,
        loading: true,
        error: "",
      };
      break;
    case GET_CURRENT_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        currentUser: action.payload,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case RESET_PASSWORD:
      state = {
        ...state,
        loading: true,
        successMsg: "",
      };
      break;
    case RESET_PASSWORD_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        successMsg: action.payload,
      };
      break;
    case RESET_PASSWORD_FAIL:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        successMsg: "",
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
